var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-0" }, [
    _c("div", { staticClass: "col-xs-12 p-0 font-14 color-light-black" }, [
      _vm._v("Preview"),
    ]),
    _c("div", { staticClass: "col-xs-12 p-10 preview-wrapper mt-5 mb-30" }, [
      _c("div", { staticClass: "content-holder col-xs-12 pl-0" }, [
        _c("div", { staticClass: "col-xs-12 p-0 mb-20" }, [
          _c("strong", { staticClass: "font-14 bg-black" }, [_vm._v("Title:")]),
          _c("div", {
            staticClass: "font-16 font-300 mb-0 title-wrapper",
            domProps: { innerHTML: _vm._s(_vm.alertDetails.title) },
          }),
        ]),
        _c("div", { staticClass: "col-xs-12 p-0 mb-30" }, [
          _c("strong", { staticClass: "font-14 bg-black" }, [
            _vm._v("Country:"),
          ]),
          _c("div", { staticClass: "font-16 font-300" }, [
            _vm._v(_vm._s(_vm.alertDetails.countryName)),
          ]),
        ]),
        _c("div", { staticClass: "col-xs-12 p-0 mb-30" }, [
          _c("strong", { staticClass: "font-14 bg-black" }, [
            _vm._v("Effective Date:"),
          ]),
          _c("div", { staticClass: "font-16 font-300" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm._f("dateFormatter")(
                    _vm.alertDetails.regulatoryEffectiveDate
                  )
                ) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "col-xs-12 p-0 mb-30" }, [
          _c("strong", { staticClass: "font-14 bg-black" }, [
            _vm._v("Description:"),
          ]),
          _c("div", {
            staticClass: "font-16",
            attrs: { id: "description" },
            domProps: {
              innerHTML: _vm._s(
                _vm.alertDetails.description.replace(/\n/g, "<br/>")
              ),
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }